module.exports = __webpack_public_path__ + "media/images/logo-text-vert-8d9d60d2866c3a5356374dea1bb18839.svg";